import { render, staticRenderFns } from "./AreaProdutiva2009.vue?vue&type=template&id=3141091b&lang=pug"
import script from "./AreaProdutiva2009.vue?vue&type=script&lang=js"
export * from "./AreaProdutiva2009.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports